// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"MediaPlayer_playerWrapper__yc_Cq","video":"MediaPlayer_video__rHatB","audio":"MediaPlayer_audio__MUl0O"};